<template>
  <div class="header">
    <div class="main-width">
      <div class="header-left">
        <div class="logo-box" @click="$router.push('/index')">
          <img src="../../assets/img/logo.jpg" alt="logo" class="logo" />
        </div>
      </div>
      <div class="header-title">{{$t('home.title')}}</div>
      <div class="header-middle">
        <ul>
          <li @click="$router.push('/index')">
            <a :class="{ 'active-color': path == '/index' }">{{
              $t("home.index")
            }}</a>
          </li>
          <li class="header-dropdown-box">
            <a :class="{ 'active-color': path == '/talentIntroduce' }">{{
              $t("home.talent")
            }}</a>
            <div
              class="header-dropdown"
              :class="{ li_w_300: $i18n.locale == 'en' }"
            >
              <ol>
                <li @click="$router.push('/talentIntroduce?type=0')">
                  <a>{{ $t("home.talent1") }}</a>
                </li>
                <li @click="$router.push('/talentIntroduce?type=1')">
                  <a>{{ $t("home.talent2") }}</a>
                </li>
                <li @click="$router.push('/talentIntroduce?type=2')">
                  <a>{{ $t("home.talent3") }}</a>
                </li>
                <li @click="$router.push('/talentIntroduce?type=3')">
                  <a>{{ $t("home.talent4") }}</a>
                </li>
                <li @click="$router.push('/talentIntroduce?type=4')">
                  <a>{{ $t("home.talent5") }}</a>
                </li>
                <li @click="$router.push('/talentIntroduce?type=5')">
                  <a>{{ $t("home.talent6") }}</a>
                </li>
                <li @click="$router.push('/talentIntroduce?type=6')">
                  <a>{{ $t("home.talent7") }}</a>
                </li>
                <li @click="$router.push('/talentIntroduce?type=7')">
                  <a>{{ $t("home.talent8") }}</a>
                </li>
              </ol>
            </div>
          </li>
          <li
            class="header-dropdown-box"
            :class="{ li_w_300: $i18n.locale == 'en' }"
          >
            <a :class="{ 'active-color': path == '/planIntroduce' }">{{
              $t("home.plan")
            }}</a>
            <div class="header-dropdown">
              <ol>
                <li @click="$router.push('/planIntroduce?type=0')">
                  <a>{{ $t("home.plan1") }}</a>
                </li>
                <li @click="$router.push('/planIntroduce?type=1')">
                  <a>{{ $t("home.plan2") }}</a>
                </li>
                <li @click="$router.push('/planIntroduce?type=2')">
                  <a>{{ $t("home.plan3") }}</a>
                </li>
                <li @click="$router.push('/planIntroduce?type=3')">
                  <a>{{ $t("home.plan4") }}</a>
                </li>
                <li @click="$router.push('/planIntroduce?type=4')">
                  <a>{{ $t("home.plan5") }}</a>
                </li>
                <li @click="$router.push('/planIntroduce?type=5')">
                  <a>{{ $t("home.plan6") }}</a>
                </li>
                <li @click="$router.push('/planIntroduce?type=6')">
                  <a>{{ $t("home.plan7") }}</a>
                </li>
                <li @click="$router.push('/planIntroduce?type=7')">
                  <a>{{ $t("home.plan8") }}</a>
                </li>
              </ol>
            </div>
          </li>
          <li @click="$router.push('/aboutUs')">
            <a :class="{ 'active-color': path == '/aboutUs' }">{{
              $t("home.aboutUs")
            }}</a>
          </li>
          <li @click="$router.push('/contactUs')">
            <a :class="{ 'active-color': path == '/contactUs' }">{{
              $t("home.contactUs")
            }}</a>
          </li>
          <li class="header-dropdown-box c_pointer">
            <a
              ><img class="icon_lang" src="../../assets/img/icon-lang.svg"
            /></a>
            <div class="header-dropdown">
              <ol>
                <li @click="setLang('zh')"><a>中文</a></li>
                <li @click="setLang('en')"><a>EN</a></li>
              </ol>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: "/index",
    };
  },
  created() {
    let lang = localStorage.getItem("lang") || "zh";
    this.$i18n.locale = lang;
  },
  mounted() {},
  methods: {
    setLang(type) {
      localStorage.setItem("lang", type);
      this.$i18n.locale = type;
    },
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        this.path = val.path;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="sss" scoped>
.header-title {
  font-size: 30px;
  padding-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/myHeader/index.vue